import {PHARMACIES} from "../pharmacyTypeDefs";
import {useQuery} from "@apollo/client";

export const useQueryPharmacies = (options?: any): any => (
  useQuery(PHARMACIES, options)
);
